import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { mocApi } from '../api/client';
import { fmtDate } from '../lib/mocUtils';
import { Skeleton, EmptyBox } from './Validations';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ListChecks, Warning, CheckCircle } from '@phosphor-icons/react';

export default function Actions() {
  const [items, setItems] = useState(null);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const onlyLate = params.get('filter') === 'late';

  useEffect(() => { mocApi.listActions().then(setItems); }, []);

  const complete = async (id) => {
    const evidence = window.prompt('Preuve / commentaire de réalisation :', 'Réalisée');
    if (evidence == null) return;
    const res = await mocApi.closeAction(id, evidence || 'Réalisée');
    if (res.ok) { setItems((list) => list.map((a) => a.id === id ? { ...a, status: 'terminee' } : a)); toast.success('Action marquée réalisée'); }
    else toast.error(res.error || "L'action a échoué");
  };

  const list = (items || []).filter((a) => !onlyLate || a.status === 'en_retard');

  return (
    <div className="space-y-5">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Suivi des actions</div>
          <h1 className="font-display text-3xl font-black tracking-tight mt-1">{onlyLate ? 'Actions en retard' : 'Mes actions'}</h1>
        </div>
      </div>

      {!items ? <Skeleton /> : list.length === 0 ? (
        <EmptyBox icon={ListChecks} text="Aucune action." />
      ) : (
        <div className="space-y-2">
          {list.map((a) => (
            <Card key={a.id} data-testid={`action-item-${a.id}`} className="rounded-sm p-4 flex items-center gap-4">
              <div className={`w-2.5 h-2.5 rounded-full shrink-0 ${a.status === 'terminee' ? 'bg-emerald-500' : a.status === 'en_retard' ? 'bg-red-500' : 'bg-amber-500'}`} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold">{a.title}</span>
                  {a.blocking && <span className="text-xs font-semibold text-red-600 inline-flex items-center gap-1"><Warning size={13} weight="bold" />Bloquante</span>}
                </div>
                <button onClick={() => navigate(`/moc/${a.mocId}`)} className="text-xs text-muted-foreground hover:text-primary">
                  {a.mocId} · échéance {fmtDate(a.due)} · {a.source}
                </button>
              </div>
              {a.status === 'terminee' ? (
                <span className="text-xs text-emerald-600 font-semibold inline-flex items-center gap-1"><CheckCircle size={16} weight="fill" />Terminée</span>
              ) : (
                <Button size="sm" variant="outline" data-testid={`complete-${a.id}`} onClick={() => complete(a.id)}>Terminer</Button>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
